import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Icon from './Icon';

function createSvgIcon(_ref) {
  var as = _ref.as,
      ariaLabel = _ref.ariaLabel,
      displayName = _ref.displayName,
      category = _ref.category;
  var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(Icon, _extends({
      "aria-label": ariaLabel,
      "data-category": category,
      ref: ref,
      as: as
    }, props));
  });
  IconComponent.displayName = displayName;
  return IconComponent;
}

export default createSvgIcon;